import { IdCard, FileCheck2, ShieldCheck, AlertTriangle } from "lucide-react";
import { CTA_IMG, waLink } from "../../lib/site";
import { Reveal, Overline } from "./ui";

const reqs = [
  {
    icon: IdCard,
    title: "Valid Driving License",
    desc: "Original required at the time of pickup. It must be valid for the vehicle category you are renting.",
  },
  {
    icon: FileCheck2,
    title: "Govt Photo ID",
    desc: "Aadhaar, Voter ID or Passport. One valid government-issued photo identity for verification.",
  },
  {
    icon: ShieldCheck,
    title: "Security Deposit",
    desc: "A refundable security deposit is collected at pickup and returned on safe vehicle return. Amount confirmed on enquiry.",
  },
];

export default function Terms() {
  return (
    <section id="requirements" className="relative px-5 py-24 md:px-10 md:py-32">
      <div className="absolute inset-0 z-0">
        <img src={CTA_IMG} alt="" aria-hidden className="h-full w-full object-cover opacity-30" />
        <div className="absolute inset-0 bg-ink/85" />
      </div>

      <div className="relative z-10 mx-auto max-w-[1400px]">
        <Reveal className="mb-14 max-w-2xl">
          <Overline>Rental Requirements</Overline>
          <h2 className="mt-4 font-heading text-3xl font-bold uppercase tracking-tight text-white sm:text-4xl md:text-5xl">
            Simple, transparent terms
          </h2>
          <p className="mt-4 text-sm text-white/60 md:text-base">
            Bring these along at pickup so you can hit the road without delays.
          </p>
        </Reveal>

        <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
          {reqs.map((r, i) => (
            <Reveal key={r.title} delay={i * 0.1}>
              <div className="h-full border border-white/10 bg-ink/60 p-7 backdrop-blur-sm">
                <r.icon className="text-volt" size={26} />
                <h3 className="mt-5 font-heading text-xl font-bold tracking-tight text-white">{r.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-white/60">{r.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.15}>
          <div className="mt-8 flex flex-col items-start gap-4 border border-volt/30 bg-volt/[0.06] p-6 md:flex-row md:items-center md:justify-between">
            <div className="flex items-start gap-3">
              <AlertTriangle className="mt-0.5 shrink-0 text-volt" size={20} />
              <p className="text-sm text-white/80">
                <span className="font-bold text-white">No online payments.</span> All bookings are finalized in person or
                over direct communication — WhatsApp or a phone call.
              </p>
            </div>
            <a
              href={waLink()}
              target="_blank"
              rel="noreferrer"
              data-testid="terms-whatsapp-cta"
              className="inline-flex shrink-0 items-center justify-center gap-2 bg-volt px-6 py-3.5 text-xs font-bold uppercase tracking-wider text-ink transition-colors hover:bg-volt-hover"
            >
              Enquire Now
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
